import { appCopy } from '../../app-ui/baseline';
import { searchContent } from '../discovery/presentation';
import { albumPath } from '../../components/content/albumPath';

export function assistItems(results, locale) {
  return ['artist', 'album', 'playlist'].flatMap((kind) => {
    const item = results?.[`${kind}s`]?.items?.[0];
    if (!item) return [];
    const meta =
      kind === 'album'
        ? appCopy(locale, 'search.albumReviewMeta', { count: item.commentCount ?? 0 })
        : appCopy(locale, `common.${kind}`);
    return [{ kind, item, meta }];
  });
}
export function emptyAssistItems(home = {}, discovery, locale) {
  const featured =
    home.recommendedReviews?.[0] ?? home.featuredReviews?.[0] ?? home.latestReviews?.[0];
  const content = searchContent(discovery, home);
  const items = [];
  const album = (item) => ({
    ...item,
    title: item.albumTitle,
    albumImageUrl: item.albumImageUrl,
    contentRating: item.albumContentRating,
  });
  if (featured)
    items.push({
      kind: 'album',
      item: album(featured),
      to: albumPath(featured),
      meta: appCopy(locale, 'search.albumReviewMeta', { count: featured.albumReviewCount ?? 0 }),
    });
  const review = content.reviews[0];
  if (review)
    items.push({
      kind: 'album',
      review: true,
      item: {
        ...album(review),
        title: review.content?.replace(/^[“"']+|[”"']+$/g, '').trim() || review.albumTitle,
        contentRating: undefined,
      },
      to: `${albumPath(review)}/user-reviews/${encodeURIComponent(review.reviewId)}`,
      meta: appCopy(locale, 'search.reviewBy', { user: review.userNickname }),
    });
  if (content.playlists[0])
    items.push({
      kind: 'playlist',
      item: content.playlists[0],
      meta: appCopy(locale, 'common.playlist'),
    });
  return items;
}
